// ------------------------------
//　ヘッダー
$(function () {
  const $hamburger = $('.kashima-header__hamburger');
  const $nav = $('.kashima-header__nav');
  const $bg = $('.nav-bg');

  // ハンバーガークリック
  $hamburger.on('click', function () {
    $nav.toggleClass('is-active');
    $bg.toggleClass('is-active');
  });

  // 背景クリックで閉じる
  $bg.on('click', function () {
    $nav.removeClass('is-active');
    $bg.removeClass('is-active');
  });
});
//　ヘッダー 第二階層
$(function () {
  const BP = 1000;
  const isSP = () => window.matchMedia(`(max-width:${BP}px)`).matches;

  $('.kashima-nav__link--nolink').on('click', function (e) {
    if (!isSP()) return;
    e.preventDefault();
    $(this).next('.kashima-nav__sub').stop(true, true).slideToggle(200);
  });
});
//　サイドナビ
$(function () {
  const $win = $(window);
  const $header = $('#kashima_header');
  const $wrap = $('.kashima-header-wrap');

  let lastScrollTop = 0;
  let headerHeight = $header.outerHeight();
  let wrapTop = 0; // 元の位置（document上のY）

  function recalc() {
    const wasFixed = $header.hasClass('is-fixed');
    if (wasFixed) $header.removeClass('is-fixed is-hide');

    headerHeight = $header.outerHeight();
    wrapTop = $wrap.offset().top;

    if (wasFixed) {
      if ($win.scrollTop() > wrapTop) $header.addClass('is-fixed');
    }
  }

  recalc();
  $win.on('resize', recalc);

  $win.on('scroll', function () {
    const st = $win.scrollTop();

    if (st > wrapTop) {
      $header.addClass('is-fixed');
    } else {
      $header.removeClass('is-fixed is-hide');
      lastScrollTop = st;
      return; // 元の位置に戻ったら隠す判定も不要
    }

    // 追従中だけ「下で隠す / 上で出す」
    if (st > lastScrollTop && st > (wrapTop + headerHeight)) {
      $header.addClass('is-hide');
    } else {
      $header.removeClass('is-hide');
    }

    lastScrollTop = st;
  });
});

//　ーーーーーーーーー
// faq　アコーディオン
$(function () {
  $('.kashima-faq__q').on('click', function () {
    const $q = $(this);
    const $a = $q.next('.kashima-faq__a');
    if ($q.hasClass('is-active')) {
      // 閉じる
      $q.removeClass('is-active');
      $a.slideUp();
    } else {
      // 開く
      $q.addClass('is-active');
      $a.slideDown();
    }
  });
});

//　ーーーーーーーーー
// サービスページ　画像切り替え
$(function () {
  $(document).on('click', '.kashima-service-sec01 .image-box .image-list img', function (e) {
    e.preventDefault();

    var $thumb = $(this);
    var $imageBox = $thumb.closest('.image-box');
    var $mainImg = $imageBox.find('figure.main img');

    if (!$mainImg.length) return;

    var thumbSrc = $thumb.attr('src');
    if (!thumbSrc) return;

    var mainSrc = thumbSrc.replace(/width=\d+/i, 'width=1400');

    // 同じなら何もしない
    if ($mainImg.attr('src') === mainSrc) return;

    $mainImg.stop(true, true).fadeOut(150, function () {
      $mainImg.attr('src', mainSrc).fadeIn(150);
    });
  });

});

//　ーーーーーーーーー
// ページサイドメニュー
$(function () {
  var $wrap = $('.kashima-page__wrap');
  var $sidebar = $wrap.find('.kashima-page__sidebar');
  var $menu = $wrap.find('.kashima-page__menu');

  if (!$wrap.length || !$sidebar.length || !$menu.length) return;

  // scrollspy対象（メニューのhrefにあるIDを拾う）
  var $links = $menu.find('a[href^="#"]');

  function getTargets() {
    return $links
      .map(function () {
        var id = $(this).attr('href');
        var $t = $(id);
        return $t.length ? $t[0] : null;
      })
      .toArray()
      .map(function (el) { return $(el); });
  }

  var targets = getTargets();
  var rafId = null;

  function updateSticky() {
    var wrapTop = $wrap.offset().top;
    var wrapH = $wrap.outerHeight();
    var wrapBottom = wrapTop + wrapH;

    var scrollTop = $(window).scrollTop();
    var winH = $(window).height();

    // 上の余白
    var topOffset = 100; // 好みで 0 / 10 / 70 など

    // メニューの高さ
    var menuH = $menu.outerHeight(true);

    // wrapの中で固定するための境界
    // 固定開始：wrapTop - topOffset を超えたら
    // 固定終了：wrapBottom - menuH - topOffset を超えたら（wrap下端に吸着）
    var start = wrapTop - topOffset;
    var end = wrapBottom - menuH - topOffset;

    if (scrollTop < start) {
      // まだwrapに来てない：通常位置（wrap上に吸着）
      $sidebar.removeAttr('style');
      $menu.removeAttr('style');
    } else if (scrollTop >= start && scrollTop < end) {
      // wrap内：追従（fixed）
      // sidebarの左位置を固定してズレを防ぐ
      var sidebarLeft = $sidebar.offset().left;
      var sidebarW = $sidebar.outerWidth();

      $sidebar.css({
        position: 'relative'
      });

      $menu.css({
        position: 'fixed',
        top: topOffset + 'px',
        left: sidebarLeft + 'px',
        width: sidebarW + 'px'
      });
    } else {
      // wrapを過ぎた：wrap下端に吸着（absoluteで止める）
      // fixedを解除して、sidebar内の下に固定する
      $sidebar.css({
        position: 'relative'
      });

      $menu.css({
        position: 'absolute',
        top: 'auto',
        left: '0',
        width: '100%',
        bottom: '0'
      });
    }
  }

  function updateActive() {
    // 現在位置の判定基準
    var scrollTop = $(window).scrollTop();
    var offset = 120;

    // ターゲットの位置を見て、今いるセクションを決める
    var currentId = null;

    for (var i = 0; i < targets.length; i++) {
      var $t = targets[i];
      if (!$t || !$t.length) continue;

      var top = $t.offset().top;
      if (scrollTop + offset >= top) {
        currentId = $t.attr('id');
      }
    }

    // liに is-active を付ける
    $menu.find('li').removeClass('is-active');
    if (currentId) {
      $menu.find('a[href="#' + currentId + '"]').closest('li').addClass('is-active');
    }
  }

  function onScrollResize() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      // targetsが動く（画像遅延読み込み等）可能性があるので、必要なら更新
      targets = getTargets();

      updateSticky();
      updateActive();
    });
  }

  // 初回
  onScrollResize();

  // スクロール/リサイズ
  $(window).on('scroll', onScrollResize);
  $(window).on('resize', onScrollResize);

  // 画像読み込みで高さが変わる場合の保険
  $(window).on('load', onScrollResize);

  // メニュークリックでのジャンプ（任意：スムーススクロール）
  $(document).on('click', '.kashima-page__menu a[href^="#"]', function (e) {
    var href = $(this).attr('href');
    var $t = $(href);
    if (!$t.length) return;

    e.preventDefault();
    var topOffset = 100; // stickyと同じ値に
    $('html, body').animate({ scrollTop: $t.offset().top - topOffset }, 300);
  });
});

// アカウント
$(function () {

  // 開く
  $('.kashima-addresses-form-btn').on('click', function () {
    const $form = $('.add-address');
    const $bg   = $form.next('.add-address-bg'); // 次の要素（bg）

    $form.stop(true, true).fadeIn(200);
    $bg.stop(true, true).fadeIn(200);
  });

  // 閉じる共通処理
  function closeAddress01() {
    const $form = $('.add-address');
    const $bg   = $form.next();

    $form.stop(true, true).fadeOut(200);
    $bg.stop(true, true).fadeOut(200);
  }

  // ×ボタン
  $('.add-address .close').on('click', function () {
    closeAddress01();
  });

  // 背景クリック
  $('.add-address').next('.add-address-bg').on('click', function () {
    closeAddress01();
  });

  // キャンセル
  $('.add-address .reset').on('click', function () {
    closeAddress01();
  });


  // 開く
  $('.kashima-address-edit').on('click', function () {
    const $li   = $(this).closest('li');
    const $form = $li.find('.kashima-address-edit-form').first();
    const $bg   = $li.find('.edit-address-bg').first();
    $form.stop(true, true).fadeIn(200);
    $bg.stop(true, true).fadeIn(200);
  });

  // 閉じる共通処理
  function closeAddress02() {
    const $form = $('.kashima-address-edit-form');
    const $bg   = $form.next();
    $form.stop(true, true).fadeOut(200);
    $bg.stop(true, true).fadeOut(200);
  }

  // ×ボタン
  $('.kashima-address-edit-form .close').on('click', function () {
    closeAddress02();
  });

  // 背景クリック
  $('.kashima-address-edit-form').next('.edit-address-bg').on('click', function () {
    closeAddress02();
  });

  // キャンセル
  $('.kashima-address-edit-form .reset').on('click', function () {
    closeAddress02();
  });

});
//-----------------------------------
// 強み
$(function () {
  var $wrap = $('.kashima-strengths-wedo__wrap');
  if (!$wrap.length) return;

  var $boxes = $wrap.find('.box');
  var firedPc = false;

  function checkFadeIn() {
    var winTop = $(window).scrollTop();
    var winBottom = winTop + $(window).height();

    // ===== PC =====
    if (window.innerWidth >= 769) {
      if (firedPc) return;

      var triggerPos = $wrap.offset().top + 100;

      if (winBottom >= triggerPos) {
        firedPc = true;

        $boxes.each(function (index) {
          $(this)
            .delay(index * 400)
            .queue(function (next) {
              $(this).addClass('fade-in');
              next();
            });
        });
      }

    // ===== SP =====
    } else {
      $boxes.each(function () {
        var $box = $(this);
        if ($box.hasClass('fade-in')) return;

        var boxTop = $box.offset().top;
        var triggerPos = boxTop + 100;

        if (winBottom >= triggerPos) {
          $box.addClass('fade-in');
        }
      });
    }
  }

  // スクロール時
  $(window).on('scroll', checkFadeIn);

  // 読み込み時（初期位置対策）
  checkFadeIn();
});

// 強み
$(function () {
  const $wrap = $('.kashima-strengths-tec__wrap');
  if (!$wrap.length) return;

  const boxes = $wrap.find('.box').toArray();
  if (boxes.length <= 1) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let isAnimating = false;
  let touchStartY = null;

  const isWrapActive = () => {
    // wrapがある程度画面内に入っているときだけ効かせる
    const r = $wrap[0].getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh * 0.3 && r.bottom > vh * 0.3;
  };

  const getCurrentIndex = () => {
    // 「今画面内で先頭に近いbox」を現在として扱う
    const vh = window.innerHeight || document.documentElement.clientHeight;
    let bestIdx = 0;
    let bestDist = Infinity;
    boxes.forEach((el, i) => {
      const top = el.getBoundingClientRect().top;
      const dist = Math.abs(top);
      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = i;
      }
    });

    return bestIdx;
  };

  const scrollToIndex = (idx) => {
    if (idx < 0 || idx >= boxes.length) return;
    isAnimating = true;

    // スクロールが残っている状態でも頭に合わせやすい
    boxes[idx].scrollIntoView({
      behavior: prefersReduced ? 'auto' : 'smooth',
      block: 'start'
    });

    // smooth完了の確定が取りづらいので、ロック解除は時間で
    window.setTimeout(() => { isAnimating = false; }, prefersReduced ? 0 : 650);
  };

  const canSnapDown = (idx) => {
    // 最後のboxは下スナップしない
    if (idx >= boxes.length - 1) return false;

    const r = boxes[idx].getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;

    // 「boxが全部見え切った」判定（余白ぶんだけ許容）
    const eps = 8;
    const fullyShown = (r.bottom <= vh + eps);

    // 「まだ見え切ってない」なら通常スクロールに任せる
    return fullyShown;
  };

  const canSnapUp = (idx) => {
    // 先頭boxより上にはスナップしない（自然スクロール）
    if (idx <= 0) return false;

    const r = boxes[idx].getBoundingClientRect();

    // 「boxの頭付近まで戻ってきた」判定
    const eps = 8;
    const nearTop = (r.top >= -eps);

    return nearTop;
  };

  const onWheel = (e) => {
    if (!isWrapActive()) return;
    if (isAnimating) { e.preventDefault(); return; }

    const deltaY = e.originalEvent ? e.originalEvent.deltaY : e.deltaY;
    const down = deltaY > 0;
    const idx = getCurrentIndex();

    if (down) {
      if (canSnapDown(idx)) {
        e.preventDefault();
        scrollToIndex(idx + 1);
      } else {
        // 見え切るまでは通常スクロール
      }
    } else {
      if (canSnapUp(idx)) {
        e.preventDefault();
        scrollToIndex(idx - 1);
      } else {
        // まだbox上端に到達してないなら通常スクロール
      }
    }
  };

  $(window).on('wheel', onWheel);
  window.addEventListener('wheel', (ev) => {
    if (!isWrapActive() || isAnimating) return;
  }, { passive: true });

  // ---- touch（スワイプ） ----
  const wrapEl = $wrap[0];

  const onTouchStart = (e) => {
    if (!isWrapActive()) return;
    if (!e.touches || !e.touches.length) return;
    touchStartY = e.touches[0].clientY;
  };

  const onTouchMove = (e) => {
    if (!isWrapActive()) return;
    if (isAnimating) { e.preventDefault(); return; }
    if (touchStartY == null) return;
    if (!e.touches || !e.touches.length) return;

    const currentY = e.touches[0].clientY;
    const diff = touchStartY - currentY; // +なら下へ進む（指は上に動く）
    const threshold = 35;

    if (Math.abs(diff) < threshold) return;

    const down = diff > 0;
    const idx = getCurrentIndex();

    if (down) {
      if (canSnapDown(idx)) {
        e.preventDefault();
        touchStartY = null;
        scrollToIndex(idx + 1);
      }
    } else {
      if (canSnapUp(idx)) {
        e.preventDefault();
        touchStartY = null;
        scrollToIndex(idx - 1);
      }
    }
  };

  const onTouchEnd = () => { touchStartY = null; };

  // passive:false が超重要（preventDefaultするため）
  wrapEl.addEventListener('touchstart', onTouchStart, { passive: true });
  wrapEl.addEventListener('touchmove', onTouchMove, { passive: false });
  wrapEl.addEventListener('touchend', onTouchEnd, { passive: true });
});

// 施工について
// 強み
$(function () {
  var $wrap = $('.kashima-installation-wedo__wrap');
  if (!$wrap.length) return;

  var $boxes = $wrap.find('.box');
  var firedPc = false;

  function checkFadeIn() {
    var winTop = $(window).scrollTop();
    var winBottom = winTop + $(window).height();

    // ===== PC =====
    if (window.innerWidth >= 769) {
      if (firedPc) return;

      var triggerPos = $wrap.offset().top + 100;

      if (winBottom >= triggerPos) {
        firedPc = true;

        $boxes.each(function (index) {
          $(this)
            .delay(index * 400)
            .queue(function (next) {
              $(this).addClass('fade-in');
              next();
            });
        });
      }

    // ===== SP =====
    } else {
      $boxes.each(function () {
        var $box = $(this);
        if ($box.hasClass('fade-in')) return;

        var boxTop = $box.offset().top;
        var triggerPos = boxTop + 100;

        if (winBottom >= triggerPos) {
          $box.addClass('fade-in');
        }
      });
    }
  }

  // スクロール時
  $(window).on('scroll', checkFadeIn);

  // 読み込み時（初期位置対策）
  checkFadeIn();
});
